"use client";

import { createContext, useContext } from "react";

export interface ValueConflictDialogContextValue {
  name: string;
  selectedValue: string;
  select: (value: string) => void;
}

export const ValueConflictDialogContext = createContext<ValueConflictDialogContextValue | null>(
  null,
);

export const useValueConflictDialog = (): ValueConflictDialogContextValue => {
  const ctx = useContext(ValueConflictDialogContext);
  if (!ctx) throw new Error("ValueConflictDialog parts must be used within <ValueConflictDialog>.");
  return ctx;
};
